const ENDORSEMENT_CARD_ID_PREFIX = 'endorsement-';

export const getEndorsementCardElementId = (cardId: string): string => `${ENDORSEMENT_CARD_ID_PREFIX}${cardId}`;
